import { Component } from '@angular/core';

@Component({
  selector: 'app-login',
  imports: [],
  template: `
    <p>
      login works!
    </p>
  `,
  styles: ``
})
export class Login {

}
